import { render, staticRenderFns } from "./PurchasesFooterSocials.vue?vue&type=template&id=74b1be1c&scoped=true"
import script from "./PurchasesFooterSocials.vue?vue&type=script&lang=js"
export * from "./PurchasesFooterSocials.vue?vue&type=script&lang=js"
import style0 from "./PurchasesFooterSocials.vue?vue&type=style&index=0&id=74b1be1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b1be1c",
  null
  
)

export default component.exports